<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    :title="`Microsoft Azure(${
      cloudService === 'PRIVATE_PEERING'
        ? 'Private Peering'
        : 'Microsoft Peering'
    })向けVNコネクト設定`"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer
        :initial-values="{
          routeAggregationAddressList:
            form.cloudVnConnectCommon!.routeAggregationAddressList &&
            form.cloudVnConnectCommon!.routeAggregationAddressList.length > 0
              ? form.cloudVnConnectCommon!.routeAggregationAddressList
              : [''],
        }"
        v-slot="{ handleSubmit }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- クラウド設定 -->
                <v-row>
                  <v-col>
                    <h3>クラウド設定</h3>
                  </v-col>
                </v-row>
                <!-- サービスキー -->
                <v-row>
                  <v-col>
                    <app-label-group label="サービスキー">
                      <template #value>
                        <span class="ml-3" v-if="isAdd">{{
                          cloudVnMsInfo.serviceKey
                        }}</span>
                        <app-form-input
                          v-else
                          v-model="cloudVnMsInfo.serviceKey"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--ロケーション-->
                <v-row>
                  <v-col>
                    <app-label-group label="ロケーション">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo(cloudVnMsInfo.location, 'location')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--接続先仮想ネットワーク(VPN/VN)名-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="接続先仮想ネットワーク(VPN/VN)名"
                      :is-info="false"
                      :isRequired="cloudService === 'PRIVATE_PEERING' && isAdd"
                    />
                    <template
                      v-if="cloudService === 'PRIVATE_PEERING' && isAdd"
                    >
                      <validation-provider
                        name="selectedVpnVn"
                        label="接続先仮想ネットワーク(VPN/VN)名"
                        v-model="selectedVpnVn"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select-search
                          :items="vpnVnCodeSelectList"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <!--変更やMICROSOFT_PEERINGの場合、変更不可-->
                    <app-form-input v-else :value="vpnVnName" disabled />
                  </v-col>
                </v-row>

                <!-- VNコネクト設定 -->
                <v-row>
                  <v-col>
                    <h3>VNコネクト設定</h3>
                  </v-col>
                </v-row>
                <!--品目-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="品目"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="bandwidth"
                      label="品目"
                      v-model="form.cloudVnConnectCommon.bandwidth"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="bandwidthSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--QoS設定-Microsoft Peeringのみ表示-->
                <template v-if="cloudService === 'MICROSOFT_PEERING'">
                  <v-row>
                    <v-col>
                      <app-label-group label="QoS設定">
                        <template #value>
                          <v-row>
                            <v-col cols="2">
                              <span class="ml-3">ON</span>
                            </v-col>
                            <v-col cols="10">
                              <v-btn color="primary" @click="qosSettingInfo"
                                >QoS設定情報
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <v-row v-if="isBandWithType">
                    <v-col>
                      <app-badge item="割当帯域パターン" :isInfo="false" />
                      <validation-provider
                        name="qosBandControlPattern"
                        label="割当帯域パターン"
                        v-model="
                          form.cloudVnConnectCommon.qosBandControlPattern
                        "
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select
                          :items="patternOptions"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </template>
                <!--VNコネクト名(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Act)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-info="isVnConnectNameActEnable"
                      :isRequired="isVnConnectNameActEnable"
                    />
                    <validation-provider
                      name="vnConnectNameAct"
                      label="VNコネクト名(Act)"
                      v-model="form.cloudVnConnectAct.vnConnectName"
                      :rules="
                        isVnConnectNameActEnable
                          ? {
                              required: true,
                              max: { length: 20 },
                              alpha_num_zenkaku: true,
                            }
                          : undefined
                      "
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isVnConnectNameActEnable"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Sby)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-info="isVnConnectNameSbyEnable"
                      :isRequired="isVnConnectNameSbyEnable"
                    />
                    <validation-provider
                      name="vnConnectNameSby"
                      label="VNコネクト名(Sby)"
                      v-model="form.cloudVnConnectSby.vnConnectName"
                      :rules="
                        isVnConnectNameSbyEnable
                          ? {
                              required: true,
                              max: { length: 20 },
                              alpha_num_zenkaku: true,
                            }
                          : undefined
                      "
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isVnConnectNameSbyEnable"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(共通) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(共通)</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group label="ルーティング種別" value="BGP4" />
                  </v-col>
                </v-row>
                <!--AS番号-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="AS番号"
                      :is-info="false"
                      :isRequired="false"
                    />
                    <app-form-input
                      :value="
                        (form as CloudVnMsPost).cloudVnConnectAct.asNumber
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--Maximum Prefix-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="Maximum Prefix"
                      :is-info="false"
                      :isRequired="cloudService === 'PRIVATE_PEERING'"
                    />
                    <app-select
                      v-model="form.cloudVnConnectAct.maximumPrefix"
                      :items="maximumPrefixSelectList"
                      item-title="text"
                      item-value="value"
                    />
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Act) -->
                <v-row align="center">
                  <v-col cols="3">
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                  <v-col cols="9" class="d-flex align-center">
                    <v-checkbox
                      density="compact"
                      hide-details
                      v-if="showManualCheckBox"
                      v-model="isWanIpManual"
                      label="WANアドレス・ピアIPアドレスを手動入力する"
                    />
                  </v-col>
                </v-row>
                <!--WANアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="canInputWanIpAndPeerIP"
                      :isRequired="canInputWanIpAndPeerIP"
                    />
                    <validation-provider
                      name="wanAddressAct"
                      label="WANアドレス(Act)"
                      v-model="
                        (form as CloudVnMsPost).cloudVnConnectAct.wanAddress
                      "
                      :rules="
                        canInputWanIpAndPeerIP
                          ? {
                              required: true,
                              is_ip_subnet: { eq: 30 },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_not_network_ip: true,
                            }
                          : ''
                      "
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!canInputWanIpAndPeerIP"
                        :placeholder="
                          !canInputWanIpAndPeerIP
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="canInputWanIpAndPeerIP"
                      :isRequired="canInputWanIpAndPeerIP"
                    />
                    <validation-provider
                      name="peerIpAddressAct"
                      label="ピアIPアドレス(Act)"
                      v-model="
                        (form as CloudVnMsPost).cloudVnConnectAct!.peerIpAddress
                      "
                      :rules="
                        canInputWanIpAndPeerIP
                          ? {
                              required: true,
                              is_ipv4: true,
                              cross_wan_address_within_range: {
                                wan: (form as CloudVnMsPost).cloudVnConnectAct
                                  .wanAddress,
                              },
                              cross_wan_peer_consecutive: {
                                wan: (form as CloudVnMsPost).cloudVnConnectAct
                                  .wanAddress,
                              },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: {
                                range: (form as CloudVnMsPost).cloudVnConnectAct
                                  .wanAddress,
                              },
                              is_not_network_ip: {
                                range: (form as CloudVnMsPost).cloudVnConnectAct
                                  .wanAddress,
                              },
                            }
                          : ''
                      "
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!canInputWanIpAndPeerIP"
                        :placeholder="
                          !canInputWanIpAndPeerIP
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('HIGH_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('LOW_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Sby) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="canInputWanIpAndPeerIP"
                      :isRequired="canInputWanIpAndPeerIP"
                    />
                    <validation-provider
                      name="wanAddressSby"
                      label="WANアドレス(Sby)"
                      v-model="
                        (form as CloudVnMsPost).cloudVnConnectSby.wanAddress
                      "
                      :rules="
                        canInputWanIpAndPeerIP
                          ? {
                              required: true,
                              is_ip_subnet: { eq: 30 },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_not_network_ip: true,
                            }
                          : ''
                      "
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!canInputWanIpAndPeerIP"
                        :placeholder="
                          !canInputWanIpAndPeerIP
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="canInputWanIpAndPeerIP"
                      :isRequired="canInputWanIpAndPeerIP"
                    />
                    <validation-provider
                      name="peerIpAddressSby"
                      label="ピアIPアドレス(Sby)"
                      v-model="
                        (form as CloudVnMsPost).cloudVnConnectSby.peerIpAddress
                      "
                      :rules="
                        canInputWanIpAndPeerIP
                          ? {
                              required: true,
                              is_ipv4: true,
                              cross_wan_address_within_range: {
                                wan: (form as CloudVnMsPost).cloudVnConnectSby
                                  .wanAddress,
                              },
                              cross_wan_peer_consecutive: {
                                wan: (form as CloudVnMsPost).cloudVnConnectSby
                                  .wanAddress,
                              },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: {
                                range: (form as CloudVnMsPost).cloudVnConnectSby
                                  .wanAddress,
                              },
                              is_not_network_ip: {
                                range: (form as CloudVnMsPost).cloudVnConnectSby
                                  .wanAddress,
                              },
                            }
                          : ''
                      "
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!canInputWanIpAndPeerIP"
                        :placeholder="
                          !canInputWanIpAndPeerIP
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('LOW_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('HIGH_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- カスタム経路集約情報 -->
                <template v-if="cloudService === 'PRIVATE_PEERING'">
                  <v-row>
                    <v-col>
                      <h3>カスタム経路集約情報</h3>
                    </v-col>
                  </v-row>
                  <!--経路集約-->
                  <v-row>
                    <v-col>
                      <app-badge
                        item="経路集約"
                        :isRequired="false"
                        :isInfo="false"
                      />
                      <v-radio-group
                        v-model="form.cloudVnConnectCommon.routeAggregation"
                        hide-details
                        inline
                      >
                        <v-radio
                          v-for="(routeOption, index) in routeOptions"
                          :key="`${routeOption.text + index}`"
                          :label="routeOption.text"
                          :value="routeOption.value"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <!--経路集約アドレス-->
                  <v-row
                    v-if="form.cloudVnConnectCommon.routeAggregation !== 'OFF'"
                  >
                    <v-col>
                      <app-badge
                        item="経路集約アドレス"
                        :is-required="
                          form.cloudVnConnectCommon.routeAggregation ===
                          'CUSTOM'
                        "
                        :is-info="
                          form.cloudVnConnectCommon.routeAggregation ===
                          'CUSTOM'
                        "
                        :msg="$filter.message('info_routing_address')"
                      />
                      <template
                        v-if="
                          form.cloudVnConnectCommon.routeAggregation === 'ON'
                        "
                      >
                        <span class="ml-3">0.0.0.0/0</span>
                      </template>
                      <template
                        v-if="
                          form.cloudVnConnectCommon.routeAggregation ===
                          'CUSTOM'
                        "
                      >
                        <validation-array
                          name="routeAggregationAddressList"
                          v-slot="{ fields, push, remove }"
                        >
                          <template
                            v-for="(item, index) in fields"
                            :key="item.key"
                          >
                            <v-row class="ga-2">
                              <validation-provider
                                :name="`routingIp_${item.key}`"
                                label="経路集約アドレス"
                                v-model="
                                  form.cloudVnConnectCommon
                                    .routeAggregationAddressList![index]
                                "
                                :rules="{
                                  required: true,
                                  is_ip_subnet: { min: 1, max: 30 },
                                  is_network_address: true,
                                  is_not_default_root: true,
                                  duplicate: {
                                    list: routingAddressList(index),
                                  },
                                }"
                                v-slot="{ componentField, errorMessage, meta }"
                              >
                                <app-form-input
                                  class="ml-1"
                                  :placeholder="
                                    $filter.message(
                                      'placeholder_ip_address_with_subnet24'
                                    )
                                  "
                                  v-bind="componentField"
                                  :field-meta="meta"
                                  :error-messages="errorMessage"
                                />
                                <v-btn
                                  icon="$mdiMinus"
                                  size="small"
                                  variant="outlined"
                                  class="rounded-sm ml-2 mr-3"
                                  @click="removeRouteAddress(index, remove)"
                                />
                              </validation-provider>
                            </v-row>
                          </template>
                          <!--経路集約アドレス追加-CUSTOMのみ表示-->
                          <v-row justify="end">
                            <v-btn
                              icon="$mdiPlus"
                              size="small"
                              variant="outlined"
                              class="rounded-sm ml-2 mr-3"
                              :disabled="currentLength >= 100"
                              @click="addRouteAddress(push)"
                            />
                          </v-row>
                        </validation-array>
                      </template>
                    </v-col>
                  </v-row>
                </template>

                <!--備考-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="備考"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      :is-info="true"
                      :isRequired="false"
                    />
                    <validation-provider
                      name="description"
                      label="備考"
                      v-model="form.cloudVnConnectCommon.description"
                      :rules="{ max: { length: 20 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">{{
                  isAdd ? "追加" : "変更"
                }}</v-btn>
                <v-btn color="primary" variant="outlined" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type {
  BandWidth,
  CloudVnMsDetail,
  CloudVnMsInfo,
  CloudVnMsList,
  CloudVnMsPost,
  CloudVnMsPut,
  RouteAggregation,
  VpnVnCode,
  VpnVnCodes,
} from "@/apis/CloudVnMsApi";
import type { CloudLine } from "@/apis/CloudLineApi";
import type { CloudQosDetail } from "@/apis/CloudQosApi";
import MultiCloudVNConnectionConfirmMS from "@/modals/multicloud/ms/MultiCloudMsVnConnectionConfirm.vue";
import cloneDeep from "lodash/cloneDeep";
import CloudQosViewRC from "@/modals/cloudQos/CloudQosViewRC.vue";
import type { UpperLimitEntity } from "@/apis/UpperLimitApi";
import type { SaaSServiceGetEntity } from "@/apis/SaasApi";

export default defineComponent({
  name: "MultiCloudMsVnLineEdit",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    // 新規の場合用
    cloudVnMsInformation: {
      type: Object as PropType<CloudVnMsList>,
      default: undefined,
    },
    // 変更の場合用
    cloudVnMsDetail: {
      type: Object as PropType<CloudVnMsDetail>,
      default: undefined,
    },
  },
  data() {
    // 新規/更新のformデータを作成
    const form: CloudVnMsPost | CloudVnMsPut = (() => {
      if (this.cloudVnMsInformation) {
        const isPrivatePeering =
          this.cloudVnMsInformation.cloudVnConnectTotal === 0;
        // 新規
        const form: CloudVnMsPost = {
          cloudVnConnectCommon: {
            cloudServiceType: isPrivatePeering
              ? "PRIVATE_PEERING"
              : "MICROSOFT_PEERING",
            bandwidthType: "PF",
            routeAggregation: isPrivatePeering ? "OFF" : null,
            routeAggregationAddressList: isPrivatePeering ? [""] : null,
          } as CloudVnMsPost["cloudVnConnectCommon"],
          cloudVnConnectAct: (isPrivatePeering
            ? {
                asNumber: 12076,
                maximumPrefix: 100,
              }
            : {
                asNumber: 12076,
                maximumPrefix: null,
              }) as CloudVnMsPost["cloudVnConnectAct"],
          cloudVnConnectSby: (isPrivatePeering
            ? {
                asNumber: 12076,
                maximumPrefix: 100,
              }
            : {
                asNumber: 12076,
                maximumPrefix: null,
              }) as CloudVnMsPost["cloudVnConnectSby"],
          cloudVnMsKeyId: this.cloudVnMsInformation.cloudVnMsKeyId,
        };
        return form;
      } else {
        const cloudVnMsDetailCopy: CloudVnMsDetail | undefined = cloneDeep(
          this.cloudVnMsDetail
        );
        // 変更・経路集約アドレスを数値昇順でソート
        const common = cloudVnMsDetailCopy!.cloudVnConnectCommon;
        if (common && Array.isArray(common.routeAggregationAddressList)) {
          common.routeAggregationAddressList =
            common.routeAggregationAddressList.sortIpAddress();
        }
        const form: CloudVnMsPut = {
          cloudVnConnectCommon: {
            ...common,
            qosBandControlPattern: common.qos?.qosBandControlPattern ?? null,
          },
          cloudVnConnectAct: cloudVnMsDetailCopy!.cloudVnConnectAct,
          cloudVnConnectSby: cloudVnMsDetailCopy!.cloudVnConnectSby,
          cloudVnMsKeyId: cloudVnMsDetailCopy!.cloudVnMsKeyId,
        };
        return form;
      }
    })();

    return {
      form,
      isLoaded: false,
      privatePeeringDetail: {} as CloudVnMsDetail,
      vpnVnCodeList: [] as VpnVnCodes["cloudVnConnectsList"],
      saasServiceMst: {} as SaaSServiceGetEntity,
      cloudLineMaxBandwidth: {} as CloudLine["bandwidth"],
      qos: {} as CloudQosDetail,
      /**手動入力チェックボックス*/
      isWanIpManual: false,
      selectedVpnVn: null as null | VpnVnCode,
      patternOptions: [
        { value: "PATTERN_A", text: "パターンA" },
        { value: "PATTERN_B", text: "パターンB" },
      ],
      bandwidthOptions: [
        { text: "10Mbps", value: { value: 10, unit: "MBPS" } },
        { text: "20Mbps", value: { value: 20, unit: "MBPS" } },
        { text: "30Mbps", value: { value: 30, unit: "MBPS" } },
        { text: "40Mbps", value: { value: 40, unit: "MBPS" } },
        { text: "50Mbps", value: { value: 50, unit: "MBPS" } },
        { text: "60Mbps", value: { value: 60, unit: "MBPS" } },
        { text: "70Mbps", value: { value: 70, unit: "MBPS" } },
        { text: "80Mbps", value: { value: 80, unit: "MBPS" } },
        { text: "90Mbps", value: { value: 90, unit: "MBPS" } },
        { text: "100Mbps", value: { value: 100, unit: "MBPS" } },
        { text: "200Mbps", value: { value: 200, unit: "MBPS" } },
        { text: "300Mbps", value: { value: 300, unit: "MBPS" } },
        { text: "400Mbps", value: { value: 400, unit: "MBPS" } },
        { text: "500Mbps", value: { value: 500, unit: "MBPS" } },
        { text: "600Mbps", value: { value: 600, unit: "MBPS" } },
        { text: "700Mbps", value: { value: 700, unit: "MBPS" } },
        { text: "800Mbps", value: { value: 800, unit: "MBPS" } },
        { text: "900Mbps", value: { value: 900, unit: "MBPS" } },
        { text: "1Gbps", value: { value: 1, unit: "GBPS" } },
        { text: "2Gbps", value: { value: 2, unit: "GBPS" } },
        { text: "3Gbps", value: { value: 3, unit: "GBPS" } },
        { text: "4Gbps", value: { value: 4, unit: "GBPS" } },
        { text: "5Gbps", value: { value: 5, unit: "GBPS" } },
        { text: "6Gbps", value: { value: 6, unit: "GBPS" } },
        { text: "7Gbps", value: { value: 7, unit: "GBPS" } },
        { text: "8Gbps", value: { value: 8, unit: "GBPS" } },
        { text: "9Gbps", value: { value: 9, unit: "GBPS" } },
        { text: "10Gbps", value: { value: 10, unit: "GBPS" } },
      ] as { text: string; value: BandWidth }[],
      routeOptions: [
        { value: "ON", text: "ON" },
        { value: "OFF", text: "OFF" },
        { value: "CUSTOM", text: "CUSTOM" },
      ],
      /** Maximum Prefix上限値(変更の場合用) */
      maximumPrefixLimit: null as UpperLimitEntity | null,
      /** 1G超VNコネクト */
      vnConnects1G: null as UpperLimitEntity | null,
    };
  },
  computed: {
    /** VNコネクト(Act)名編集可否 */
    isVnConnectNameActEnable() {
      if (this.isAdd) {
        return true;
      }
      return !this.cloudVnMsDetail!.cloudVnConnectAct.isVnConnectStatus;
    },
    /** VNコネクト(Sby)名編集可否 */
    isVnConnectNameSbyEnable() {
      if (this.isAdd) {
        return true;
      }
      return !this.cloudVnMsDetail!.cloudVnConnectSby.isVnConnectStatus;
    },
    currentLength(): number {
      return this.form.cloudVnConnectCommon.routeAggregationAddressList
        ? this.form.cloudVnConnectCommon.routeAggregationAddressList.length
        : 0;
    },
    /** true: 新規, false: 変更 */
    isAdd(): boolean {
      return this.cloudVnMsInformation !== undefined;
    },
    /** 新規/変更共通情報 */
    cloudVnMsInfo(): CloudVnMsInfo {
      return this.isAdd ? this.cloudVnMsInformation! : this.cloudVnMsDetail!;
    },
    /** Private Peering / Microsoft Peering */
    cloudService(): "PRIVATE_PEERING" | "MICROSOFT_PEERING" {
      if (this.isAdd) {
        // 追加の場合
        return this.cloudVnMsInformation!.cloudVnConnectTotal === 0
          ? "PRIVATE_PEERING"
          : "MICROSOFT_PEERING";
      } else {
        // 変更の場合
        return this.cloudVnMsDetail!.cloudVnConnectCommon.cloudServiceType;
      }
    },
    vpnVnCodeSelectList(): {
      value: string;
      text: string;
    }[] {
      return this.vpnVnCodeList.map((v) => {
        if (v.vpnVnCode.startsWith("D")) {
          const mst = this.saasServiceMst.saasServiceList.find(
            (item) => item.saasCommon.vpnVnCode === v.vpnVnCode
          );
          return mst
            ? {
                value: v.vpnVnCode,
                text:
                  mst.saasCommon.vnName +
                  ":" +
                  mst.saasCommon.vpnVnCode +
                  "(L3)",
              }
            : { value: v.vpnVnCode, text: v.vpnVnCode };
        } else {
          return { value: v.vpnVnCode, text: v.vpnVnCode };
        }
      });
    },
    bandwidthSelectList(): { text: string; value: BandWidth }[] {
      // クラウド帯域値
      const limit1 = this.$filter.bandwidthToBps(this.cloudLineMaxBandwidth);
      // 1G超VNコネクト
      const limit2 = this.$filter.bandwidthToBps({
        value: this.vnConnects1G!.upperLimit,
        unit: "GBPS",
      });
      return this.bandwidthOptions.filter((v) => {
        const bps = this.$filter.bandwidthToBps(v.value)!;
        return bps <= limit1! && bps <= limit2!;
      });
    },
    /** Maximum Prefixの選択肢 */
    maximumPrefixSelectList(): { text: string; value: number | null }[] {
      if (this.cloudService === "MICROSOFT_PEERING") {
        // MICROSOFT_PEERINGの場合、'-'のみ表示
        return [{ value: null, text: "-" }];
      } else {
        if (this.isAdd) {
          return [{ value: 100, text: "100" }];
        } else {
          return [
            { value: 100, text: "100" },
            { value: 200, text: "200" },
            { value: 300, text: "300" },
            { value: 400, text: "400" },
            { value: 500, text: "500" },
            { value: 1000, text: "1000" },
            { value: 1500, text: "1500" },
            { value: 2000, text: "2000" },
          ].filter((v) => v.value <= this.maximumPrefixLimit!.upperLimit);
        }
      }
    },

    showManualCheckBox(): boolean {
      return this.cloudService === "MICROSOFT_PEERING" && this.isAdd;
    },

    canInputWanIpAndPeerIP(): boolean {
      if (this.isAdd) {
        return (
          this.cloudService === "PRIVATE_PEERING" ||
          (this.cloudService === "MICROSOFT_PEERING" && this.isWanIpManual)
        );
      } else {
        return false;
      }
    },

    vpnVnName(): string {
      if (this.isAdd) {
        // 追加の場合
        return this.getVpnVnName({
          vpnVnCode: this.privatePeeringDetail.cloudVnConnectCommon.vpnVnCode,
          vnName: this.privatePeeringDetail.cloudVnConnectCommon.vnName,
        });
      } else {
        // 変更の場合
        return this.getVpnVnName({
          vpnVnCode: this.cloudVnMsDetail!.cloudVnConnectCommon.vpnVnCode,
          vnName: this.cloudVnMsDetail!.cloudVnConnectCommon.vnName,
        });
      }
    },
    isBandWithType(): boolean {
      return this.qos && this.qos.qosType === "BANDWIDTH";
    },
    /** 経路集約アドレスの重複チェック用リスト作成 */
    routingAddressList() {
      return (index: number) => {
        return this.form.cloudVnConnectCommon!.routeAggregationAddressList
          ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
  },
  watch: {
    /** 経路集約がCUSTOMに変更されて初期値が存在しない場合は初期化 */
    "form.cloudVnConnectCommon.routeAggregation"(newValue: RouteAggregation) {
      if (
        newValue === "CUSTOM" &&
        (!this.form.cloudVnConnectCommon.routeAggregationAddressList ||
          this.form.cloudVnConnectCommon.routeAggregationAddressList.length ===
            0)
      ) {
        this.form.cloudVnConnectCommon.routeAggregationAddressList = [""];
      }
    },
  },
  async mounted() {
    await this.load();

    if (this.isAdd && this.cloudService === "MICROSOFT_PEERING") {
      // 追加&MICROSOFT_PEERINGの場合はPRIVATE_PEERINGのvpnを設定
      (this.form as CloudVnMsPost).cloudVnConnectCommon.vpnVnCode =
        this.privatePeeringDetail.cloudVnConnectCommon.vpnVnCode;
    }

    this.isLoaded = true;
  },
  methods: {
    async load() {
      // 回線情報に紐づくクラウド回線情報を取得APIを呼び出す
      const lines = (await this.$api.cloudLine.getCloudLines()).lineList;
      const cloudLines = lines.flatMap((v) => v.cloudLineList);
      // クラウド回線の帯域最大値(品目の上限値制御用)
      this.cloudLineMaxBandwidth = cloudLines.find(
        (v: { cloudLineSeq: string }) => v.cloudLineSeq === this.cloudLineSeq
      )!.bandwidth;

      // 1G超VNコネクトの値を取得（品目の上限値制御用）
      this.vnConnects1G = (
        await this.$api.upperLimit.getUpperLimitLine({
          upperLimitLineManageUnit: "MULTI_CLOUD",
          cloudLineSeq: this.cloudLineSeq,
        })
      ).cloudLine!.upperLimitList!.find(
        (v: { upperLimitItemName: string }) =>
          v.upperLimitItemName === "1G超VNコネクト"
      )!;
      if (this.isAdd) {
        // 追加の場合
        if (this.cloudService === "MICROSOFT_PEERING") {
          // MICROSOFT_PEERINGの場合
          this.privatePeeringDetail = await this.$api.cloudVnMs.getVnConnect(
            this.cloudVnMsInformation!.cloudVnConnectsList[0].cloudVnConnectAct
              .wnumber
          );
          this.qos = await this.$api.cloudQosApi.getCloudQosDetail(
            this.privatePeeringDetail.cloudVnConnectCommon.vpnVnCode
          );
        } else {
          // PRIVATE_PEERINGの場合
          this.vpnVnCodeList = (
            await this.$api.cloudVnMs.getVpnVnCodes(
              this.cloudVnMsInformation!.serviceKey!
            )
          ).sortBy(["vpnVnCode", "asc"]);
          this.saasServiceMst = await this.$api.saas.getAll();
        }
      } else {
        // 変更の場合
        if (
          this.cloudVnMsDetail!.cloudVnConnectCommon.cloudServiceType ===
          "MICROSOFT_PEERING"
        ) {
          this.qos = await this.$api.cloudQosApi.getCloudQosDetail(
            this.cloudVnMsDetail!.cloudVnConnectCommon.vpnVnCode
          );
        } else {
          // maximumPrefixの上限値を取得
          this.maximumPrefixLimit = (
            await this.$api.upperLimit.getUpperLimitLine({
              upperLimitLineManageUnit: "MULTI_CLOUD",
              cloudLineSeq: this.cloudLineSeq,
              wnumber: this.cloudVnMsDetail!.cloudVnConnectAct.wnumber,
            })
          ).cloudLine!.upperLimitList!.find(
            (v: { upperLimitItemName: string }) =>
              v.upperLimitItemName === "BGP4の最大経路数"
          )!;
        }
      }
    },

    async qosSettingInfo() {
      await this.$modal.show(CloudQosViewRC, {
        mode: "R",
        isNew: false,
        cloudQosDetail: this.qos,
      });
    },

    /** 経路集約アドレス削除 */
    removeRouteAddress(index: number, remove: (idx: number) => void) {
      const list = this.form.cloudVnConnectCommon.routeAggregationAddressList!;
      if (list.length > 1) {
        list.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.form.cloudVnConnectCommon.routeAggregationAddressList = [""];
      }
    },

    /** 経路集約アドレス追加 */
    addRouteAddress(push: (item: any) => void) {
      const addItem = "";
      this.form.cloudVnConnectCommon.routeAggregationAddressList = [
        ...this.form.cloudVnConnectCommon.routeAggregationAddressList!,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },

    getVpnVnName(info: { vpnVnCode: string; vnName: string }) {
      if (info.vpnVnCode.startsWith("D")) {
        return info.vnName + ":" + info.vpnVnCode + "(L3)";
      } else {
        return info.vpnVnCode;
      }
    },

    async submit() {
      const form = {
        ...this.form,
        cloudVnConnectCommon: {
          ...this.form.cloudVnConnectCommon,
          routeAggregationAddressList:
            this.form.cloudVnConnectCommon!.routeAggregation === "ON"
              ? []
              : this.form.cloudVnConnectCommon!.routeAggregation === "OFF"
                ? null
                : this.form.cloudVnConnectCommon!.routeAggregationAddressList,
        },
        cloudVnConnectAct: {
          ...this.form.cloudVnConnectAct,
          ...(this.showManualCheckBox && !this.isWanIpManual
            ? { wanAddress: null, peerIpAddress: null }
            : {}),
        },
        cloudVnConnectSby: {
          ...this.form.cloudVnConnectSby,
          ...(this.showManualCheckBox && !this.isWanIpManual
            ? { wanAddress: null, peerIpAddress: null }
            : {}),
        },
      } as CloudVnMsPost | CloudVnMsPut;
      //Maximum Prefix(Act)の値をMaximum Prefix(Sby)に代入する
      form.cloudVnConnectSby!.maximumPrefix =
        form.cloudVnConnectAct!.maximumPrefix;
      if (this.isAdd) {
        // 追加の場合
        let displayVnName;
        let qosInfo: CloudVnMsDetail["cloudVnConnectCommon"]["qos"] = null;
        if (this.cloudService === "MICROSOFT_PEERING") {
          displayVnName = this.privatePeeringDetail.cloudVnConnectCommon.vnName;
          qosInfo = {
            isQos: true,
            qosBandControlPattern:
              form.cloudVnConnectCommon.qosBandControlPattern,
          };
        } else {
          (form as CloudVnMsPost).cloudVnConnectCommon!.vpnVnCode =
            this.selectedVpnVn!;
          const mst = this.saasServiceMst.saasServiceList.find(
            (item) =>
              item.saasCommon.vpnVnCode ===
              (form as CloudVnMsPost).cloudVnConnectCommon.vpnVnCode
          );
          displayVnName = mst?.saasCommon.vnName;
        }

        await this.$modal.show(MultiCloudVNConnectionConfirmMS, {
          cloudVnMsDetail: {
            serviceKey: this.cloudVnMsInfo.serviceKey,
            location: this.cloudVnMsInfo.location,
            cloudVnConnectCommon: {
              ...form.cloudVnConnectCommon,
              vnName: displayVnName,
              routingType: "BGP4",
              qos: qosInfo,
            },
            cloudVnConnectAct: {
              ...form.cloudVnConnectAct,
              localPreference: "HIGH_PRIORITY",
              med: "LOW_PRIORITY",
            },
            cloudVnConnectSby: {
              ...form.cloudVnConnectSby,
              localPreference: "LOW_PRIORITY",
              med: "HIGH_PRIORITY",
            },
          },
          displayType: "A",
        });

        await this.$api.cloudVnMs.postVnConnect(
          this.cloudLineSeq,
          form as CloudVnMsPost
        );
        await (
          this.$refs.modal as typeof VueFinalModal & { ok: () => void }
        ).ok();
      } else {
        let qosInfo: CloudVnMsDetail["cloudVnConnectCommon"]["qos"] = null;
        if (this.cloudService === "MICROSOFT_PEERING") {
          qosInfo = {
            isQos: true,
            qosBandControlPattern:
              form.cloudVnConnectCommon.qosBandControlPattern,
          };
        }
        await this.$modal.show(MultiCloudVNConnectionConfirmMS, {
          cloudVnMsDetail: {
            serviceKey: this.cloudVnMsInfo.serviceKey,
            location: this.cloudVnMsInfo.location,
            cloudVnConnectCommon: {
              ...form.cloudVnConnectCommon,
              qos: qosInfo,
            },
            cloudVnConnectAct: form.cloudVnConnectAct,
            cloudVnConnectSby: form.cloudVnConnectSby,
          },
          displayType: "M",
        });
        // 変更の場合
        await this.$api.cloudVnMs.putVnConnect(
          this.cloudLineSeq,
          this.cloudVnMsDetail!.cloudVnConnectAct.wnumber,
          form as CloudVnMsPut
        );
        await (
          this.$refs.modal as typeof VueFinalModal & { ok: () => void }
        ).ok();
      }
    },
  },
});
</script>
